import React, { useEffect, useRef, useState } from 'react'
import { RouterProps, useNavigate, Link, useLocation } from 'react-router-dom'
import logo from '../logo.svg'
import './NoteList.scss'
import { Helmet } from 'react-helmet-async'
import SideMenu from '../components/SideMenu'
import store, {
  RootState,
  AppDispatch,
  useAppDispatch,
  notesSlice,
  methods,
  userSlice,
  configSlice,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { bindEvent } from '../modules/bindEvent'
import { useTranslation } from 'react-i18next'
import { snackbar, prompt, alert, multiplePrompts } from '@saki-ui/core'

import { Header } from '../components'
import { api } from '../modules/electron/api'
import { NoteItem } from '../store/notes/typings'
import { ReaderRouterProps } from '../modules/renderRoutes'
import { SyncOff } from './Icon'
import { SakiIcon } from './saki-ui-react/components'
import { httpApi } from '../modules/http/api'
import {
  getNoteMergeOrReplaceAlert,
  isNoteSync,
  isShowEnbalSyncButton,
  pushNoteMergeOrReplaceAlert,
} from '../store/notes/methods'
import { protoRoot } from '../protos'
import i18n from '../modules/i18n/i18n'

const NodeListComponent = ({
  onClick,
  onClose,
}: {
  onClick: ({ id }: { id: string }) => void
  onClose?: () => void
}) => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const notes = useSelector((state: RootState) => state.notes)
  const config = useSelector((state: RootState) => state.config)
  const user = useSelector((state: RootState) => state.user)
  const autoCloseWindowAfterCopy = useSelector(
    (state: RootState) => state.config.general.autoCloseWindowAfterCopy
  )
  const [noteContextMenuEl, setNoteContextMenuEl] = useState<any>()
  const [contentMenuActiveIndex, setContentMenuActiveIndex] =
    useState<number>(-1)

  let history = useNavigate()
  let location = useLocation()
  const [menuEl, setMenuEl] = useState<any>(null)
  const menuElRef = useRef<any>()

  const [showContext, setShowContext] = useState({
    x: 0,
    y: 0,
    label: '',
    visible: false,
  })
  const [contextMenuEl, setContextMenuEl] = useState<any>()

  useEffect(() => {
    if (showContext.visible && contextMenuEl) {
      contextMenuEl?.show({
        x: showContext.x,
        y: showContext.y,
        label: showContext.label,
      })
      return
    }
    setContextMenuEl(undefined)
  }, [showContext.visible, contextMenuEl])

  useEffect(() => {
    if (menuElRef) {
    }
  }, [menuElRef])

  return (
    <div className="note-list-component">
      <div className="page-subtitle">
        {t('notes', {
          ns: 'common',
        })}
      </div>
      <saki-menu
        ref={bindEvent(
          {
            selectvalue: async (e) => {
              // console.log(e.detail.value)
              onClose?.()
              switch (e.detail.value) {
                case 'AddNotebook':
                  onClick?.({
                    id: '',
                  })
                  await dispatch(methods.notes.AddNotebook()).unwrap()

                  break
                default:
                  onClick({
                    id: e.detail.value,
                  })
                  break
              }
              // setOpenDropDownMenu(false)
            },
          },
          (e) => {
            // setMenuEl(e)
          }
        )}
        padding="0px"
      >
        <saki-drag-sort
          ref={bindEvent({
            dragdone: (e) => {
              console.log(e.detail)
              dispatch(
                notesSlice.actions.sortNote({
                  sort: {
                    originalIndex: e.detail.oldIndex,
                    targetIndex: e.detail.newIndex,
                  },
                })
              )
            },
          })}
          sort={
            config.deviceType !== 'Mobile' || config.platform === 'Electron'
          }
        >
          {notes.list
            .filter((v) => (v.status || 0) >= 0)
            ?.map((v, i) => {
              return (
                <div key={i}>
                  <saki-menu-item
                    key={v.id}
                    ref={bindEvent({
                      opencontextmenu: (e) => {
                        console.log(e)
                        if (location.pathname !== '/quickreview') {
                          setContentMenuActiveIndex(i)
                          setShowContext({
                            x: e.detail.pageX,
                            y: e.detail.pageY,
                            label: v.id || '',
                            visible: true,
                          })
                        }
                      },
                    })}
                    none-highlight-color
                    padding="4px 18px"
                    active={
                      v.id === notes.noteId ||
                      v.id === notes.list[Number(showContext.label) || -1]?.id
                    }
                    value={v.id}
                  >
                    <div
                      data-id={v.id}
                      data-author-id={String(v.authorId)}
                      data-current-uid={String(user.userInfo.uid)}
                      className="note-item"
                    >
                      <span className="name text-elipsis">{v.name}</span>
                      {!isNoteSync(v, 5) ? (
                        <SyncOff />
                      ) : notes.permissions[v?.id || '']?.length >= 2 &&
                        notes.permissions[v?.id || '']?.filter(
                          (v) => (v.authorId || '') === user.userInfo.uid
                        ).length >= 1 ? (
                        <SakiIcon
                          margin="0 0 0 4px"
                          color="#999"
                          type="Group"
                        ></SakiIcon>
                      ) : (
                        ''
                      )}
                    </div>
                  </saki-menu-item>
                </div>
              )
            })}
        </saki-drag-sort>

        <saki-menu-item
          padding="4px 18px"
          font-size="15px"
          value={'AddNotebook'}
        >
          <div className={'note-item text-elipsis add-note'}>
            <span className="text-elipsis">
              {t('addNotebook', {
                ns: 'indexPage',
              })}
            </span>
          </div>
        </saki-menu-item>
      </saki-menu>

      <saki-context-menu
        ref={bindEvent(
          {
            close: () => {
              setShowContext({
                x: 0,
                y: 0,
                label: '',
                visible: false,
              })
            },
            selectvalue: async (e) => {
              if (e.detail.label === 'SortTo') {
                const note = notes.list.filter(
                  (v) => v.id === e.detail.values[1].label
                )?.[0]
                switch (e.detail.value) {
                  case 'MoveToTop':
                    notes.list.some((v, i) => {
                      if (v.id === note.id) {
                        dispatch(
                          notesSlice.actions.sortNote({
                            sort: {
                              originalIndex: i,
                              targetIndex: 0,
                            },
                          })
                        )
                        return true
                      }
                    })
                    break
                  case 'MoveToBottom':
                    notes.list.some((v, i) => {
                      if (v.id === note.id) {
                        dispatch(
                          notesSlice.actions.sortNote({
                            sort: {
                              originalIndex: i,
                              targetIndex: notes.list.length - 1,
                            },
                          })
                        )
                        return true
                      }
                    })
                    break
                }

                return
              }

              const note = notes.list.filter(
                (v) => v.id === e.detail.label
              )?.[0]
              noteMenuEvent(note, e.detail.value)
            },
          },
          (e) => {
            setContextMenuEl(e)
          }
        )}
      >
        <saki-context-menu-item
          width="200px"
          font-size="13px"
          padding="12px 10px"
          value="Rename"
        >
          <div className="context-menu-item">
            <SakiIcon
              color={'#666'}
              width="18px"
              height="16px"
              margin="0 6px 0 0"
              type="PenWrite"
            ></SakiIcon>
            <span>
              {t('renameThisNote', {
                ns: 'indexPage',
              })}
            </span>
          </div>
        </saki-context-menu-item>

        <saki-context-menu-item
          font-size="13px"
          padding="12px 10px"
          value="SortTo"
        >
          <div className="context-menu-item">
            <saki-icon
              margin="2px 6px 0 0"
              width="18px"
              height="14px"
              type={'Sort'}
            ></saki-icon>
            <span>
              {t('sortTo', {
                ns: 'sakiuiPrompt',
              })}
            </span>
          </div>
          <div slot="SubMenu">
            <saki-context-menu label="SortTo">
              {[
                {
                  icon: 'MoveTop',
                  value: 'MoveToTop',
                  text: t('moveToTop', {
                    ns: 'sakiuiPrompt',
                  }),
                },
                {
                  icon: 'MoveBottom',
                  value: 'MoveToBottom',
                  text: t('moveToBottom', {
                    ns: 'sakiuiPrompt',
                  }),
                },
              ].map((v, i) => {
                return (
                  <saki-context-menu-item
                    key={i}
                    font-size="13px"
                    padding="12px 10px"
                    value={v.value}
                  >
                    <div className="context-menu-item">
                      <saki-icon margin="0 6px 0 0" type={v.icon}></saki-icon>
                      <span>{v.text}</span>
                    </div>
                  </saki-context-menu-item>
                )
              })}
            </saki-context-menu>
          </div>
        </saki-context-menu-item>

        <saki-context-menu-item
          width="200px"
          font-size="13px"
          padding="12px 10px"
          value="HistoricalVersion"
          hide={!(user.isLogin && notes.list[contentMenuActiveIndex]?.isSync)}
        >
          <div className="context-menu-item">
            <SakiIcon
              color="#666"
              width="17px"
              height="17px"
              margin="0 6px 0 0"
              type="Time"
            ></SakiIcon>
            <span>
              {t('pageTitle', {
                ns: 'historicalVersionPage',
              })}
            </span>
          </div>
        </saki-context-menu-item>

        <saki-context-menu-item
          width="200px"
          font-size="13px"
          padding="12px 10px"
          value="Delete"
        >
          <div className="context-menu-item">
            <saki-icon margin="0 6px 0 0" type="Trash"></saki-icon>
            <span>
              {t('delete', {
                ns: 'common',
              })}
            </span>
          </div>
        </saki-context-menu-item>
      </saki-context-menu>
    </div>
  )
}

export const noteMenuEvent = async (
  activeNote: protoRoot.note.INoteItem,
  type: string
) => {
  const dispatch = store.dispatch
  const t = i18n.t
  const { user } = store.getState()

  switch (type) {
    case 'PushToCloud':
      await pushNoteMergeOrReplaceAlert(activeNote)
      break
    case 'PullCloudData':
      await getNoteMergeOrReplaceAlert(activeNote.id || '')
      break
    case 'HistoricalVersion':
      console.log('HistoricalVersion')

      dispatch(
        configSlice.actions.setShowAsideContentModal({
          visible: true,
          data: {
            noteId: activeNote.id || '',
            categoryId: '',
            pageId: '',
            todoId: '',
            type: 'HistoricalVersion',
          },
        })
      )
      break
    case 'Rename':
      let name = ''

      prompt({
        title: t('rename', {
          ns: 'common',
        }),
        value: activeNote.name || '',
        placeholder: t('notebookName', {
          ns: 'common',
        }),
        cancelText: t('cancel', {
          ns: 'common',
        }),
        confirmText: t('rename', {
          ns: 'common',
        }),
        onChange(e) {
          name = e
          return ''
        },
        onCancel() {},
        onConfirm() {
          if (!name) {
            snackbar({
              message: i18n.t('notebookNameNil', {
                ns: 'common',
              }),
              vertical: 'top',
              horizontal: 'center',
              autoHideDuration: 2000,
              closeIcon: true,
            }).open()
            return
          }
          dispatch(
            notesSlice.actions.updateNote({
              noteId: activeNote.id || '',
              note: {
                name,
              },
            })
          )
        },
      }).open()
      break

    case 'Share':
      dispatch(
        configSlice.actions.setShareNoteModal({
          visible: true,
          noteId: activeNote.id || '',
        })
      )
      break
    case 'Permissions':
      dispatch(
        configSlice.actions.setNotePermissionsModal({
          visible: true,
          noteId: activeNote.id || '',
        })
      )
      break
    case 'Delete':
      alert({
        title: t('delete', {
          ns: 'common',
        }),
        content: t('deleteThisNote', {
          ns: 'common',
        }),
        cancelText: t('cancel', {
          ns: 'common',
        }),
        confirmText: t('delete', {
          ns: 'common',
        }),
        onCancel() {},
        async onConfirm() {
          dispatch(
            notesSlice.actions.deleteNote({
              noteId: activeNote.id || '',
            })
          )
        },
      }).open()
      break
    case 'SaveToThisAccount':
      alert({
        title: '存储至此帐号',
        content: '存储至此帐号吗?',
        cancelText: t('cancel', {
          ns: 'common',
        }),
        confirmText: 'Save',
        onCancel() {},
        async onConfirm() {
          dispatch(
            notesSlice.actions.saveNoteToThisAccount({
              noteId: activeNote.id || '',
              uid: user.userInfo.uid,
            })
          )
        },
      }).open()
      break
    case 'Download':
      console.log('下载文件')
      // 创建隐藏的可下载链接
      const a = document.createElement('a')
      a.download = activeNote.name?.trim() + '.note'
      a.style.display = 'none'
      console.log(activeNote)
      // 字符内容转变成blob地址
      a.href = URL.createObjectURL(
        new Blob([JSON.stringify(activeNote, null, 2)])
      )
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      document.body.removeChild(a)
      break
    case 'SaveAs':
      const fileName = activeNote.name?.trim() + '.note'
      api.saveAs(fileName, JSON.stringify(activeNote, null, 2), {
        extensions: ['note'],
      })
      break
    case 'Sync':
      alert({
        title: t('sync', {
          ns: 'settings',
        }),
        content: activeNote.isSync
          ? t('turnedOffTip', {
              ns: 'common',
            })
          : t('turnedOnTip', {
              ns: 'common',
            }),
        cancelText: t('cancel', {
          ns: 'common',
        }),
        confirmText: activeNote.isSync
          ? t('turnOff', {
              ns: 'common',
            })
          : t('turnOn', {
              ns: 'common',
            }),
        onCancel() {},
        async onConfirm() {
          store.dispatch(
            methods.notes.EnableSyncNote({
              noteId: activeNote.id || '',
              isSync: !activeNote.isSync,
            })
          )
        },
      }).open()
      break
    default:
      break
  }
}

export default NodeListComponent
